'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cameraActionsList = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = camerasBySn;
exports.loadIfNeeded = loadIfNeeded;
exports.fetchRelevantCameraInfo = fetchRelevantCameraInfo;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _customers = require('./customers');

var _firmware = require('./firmware');

var _kunaUtils = require('../../utils/kunaUtils');

var _reduxUtils = require('../reduxUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: This is a bad issue - but unavoidable without some rearch because cameras *can*
// load the user and users always load all associated cameras
// eslint-disable-next-line import/no-cycle
var BASE_CAMERA_ACTION = 'camera';

/**
 * Generates URL to get the single point stat over the last day
 * @param  {string}   stat string
 * @return {function} function that takes a SN and generates URL
 */
// function generateIOBeamURL(stat, operator = 'mean', time = '1d', groupBy = '7d') {
//   return (sn) => `/ioBeam/data/master/${stat}?group_by=time%28${groupBy}%29&limit=10&operator=${operator}&output=json&time=now%28%29-${time}&timefmt=msec&where=eq%28device_id%2C${sn}%29`;
//                       // /v1/data/master/heartbeat.drastic_action.sum?group_by=time%2830d%29&limit=10&operator=sum&output=json&time=now%28%29-7d&timefmt=msec&where=eq%28device_id%2C${sn}%29
// }

// const getIoBeam = (endpoints) => {

// }

/**
 * Needs serious revamp.
 *
 * This file currently mixes both the camera and customer models
 * Instead this should just reference the camera model
 */
var cameraActionsList = exports.cameraActionsList = {
  root: {
    getPath: function getPath(sn) {
      return '/django/cameras/' + sn + '/';
    }
  },
  sight: {
    getPath: function getPath(sn) {
      return '/django/cameras/' + sn + '/sight/';
    }
  },
  schedule: {
    getPath: function getPath(sn) {
      return '/django/cameras/' + sn + '/schedule/';
    }
  },
  users: {
    getPath: function getPath(sn) {
      return '/django/cameras/' + sn + '/users/';
    }
  },
  ioBeam: {
    getPath: function getPath(sn) {
      return '/ioBeam/data/master/?limit=10000&output=json&time=now%28%29-7d&timefmt=msec&where=eq%28device_id%2C' + sn + '%29';
    }, // generateIOBeamURL('wifi.dbm.mean'),
    promise: function promise() {
      return function (response) {
        return response.result[0];
      };
    }
  },
  dynamoDB: {
    getPath: function getPath(sn) {
      // generates api gateway url to get history of a `device_id`
      var sevenDaysAgo = (0, _moment2.default)().subtract(7, 'days').unix();
      return '/dynamoDB/production-v1/logs?device_id=' + sn + '&time=' + sevenDaysAgo; // Production
      // return `/dynamoDB/test-v1/logs?device_id=${sn}&time=${sevenDaysAgo}`; // Tasos
    },
    promise: function promise() {
      return [function (response) {
        return response.result[0];
      }, function (rejection) {
        // Handles rejection due to improperly formatted JSON - where
        // ,, is replaced with ,0,
        // console.log(rejection);
        var resp = rejection.rawResponse.replace(/,(?=\s*,)/g, ',0');
        resp = resp.replace(/,(?=\s*])/g, '');
        // console.log(resp);
        var responseJson = JSON.parse(resp);
        return responseJson.result[0];
      }];
    }
  },
  wifiDataReq: {
    getPath: function getPath(sn) {
      return '/loggly/search?q=tag%3A%22' + sn + '%22%20%22wifi%22%20%22kunasync_perform%22&from=-7d&until=now&size=24';
    },
    promise: function promise(dispatch, id) {
      return function (response) {
        dispatch((0, _reduxUtils.loadIfNeeded)(id, cameraActionsList.wifiData, response.rsid.id));
        return response;
      };
    }
  },
  wifiData: {
    getPath: function getPath(sn, rsid) {
      return '/loggly/events?rsid=' + rsid;
    },
    promise: function promise() {
      return function (response) {
        return response.events.filter(function (msg) {
          var oldFormat = msg.event && msg.event.json && msg.event.json.wifi;
          var newFormat = msg.event && msg.event.json && msg.event.json.j && msg.event.json.j.j && msg.event.json.j.j.w && msg.event.json.j.j.w.wifi;
          return oldFormat || newFormat;
        });
      };
    }
  },
  errorDataReq: {
    getPath: function getPath(sn) {
      return '/loggly/search?q=tag%3A%22' + sn + '%22%20(json.severity%3A%22error%22%20OR%20severity%3A%22error%22)&from=-7d&until=now&size=10';
    },
    promise: function promise(dispatch, id) {
      return function (response) {
        dispatch((0, _reduxUtils.loadIfNeeded)(id, cameraActionsList.errorData, response.rsid.id));
        return response;
      };
    }
  },
  errorData: {
    getPath: function getPath(sn, rsid) {
      return '/loggly/events?rsid=' + rsid;
    },
    promise: function promise() {
      return function (response) {
        return response.total_events;
      };
    }
  },
  badFlashReq: {
    getPath: function getPath(sn) {
      return '/loggly/search?q=tag%3A%22' + sn + '%22%20(%22validate%20upgrade%22%20OR%20%22signature%20not%20valid%22)&from=-7d&until=now&size=10';
    },
    promise: function promise(dispatch, id) {
      return function (response) {
        dispatch((0, _reduxUtils.loadIfNeeded)(id, cameraActionsList.badFlash, response.rsid.id));
        return response;
      };
    }
  },
  badFlash: {
    getPath: function getPath(sn, rsid) {
      return '/loggly/events?rsid=' + rsid;
    },
    promise: function promise() {
      return function (response) {
        return response.total_events;
      };
    }
  }
  // drasticAction: {
  //   getPath: generateIOBeamURL('heartbeat.drastic_action.sum', 'sum', '7d', '30d'),
  //   promise: () => response => response.result[0].values[0][1]
  // },
  // wifiBitrate: {
  //   getPath: generateIOBeamURL('wifi.bitrate.mean'),
  //   promise: () => response => response.result[0].values[0][1]
  // },
  // videoUploadSpeed: {
  //   getPath: generateIOBeamURL('curl.s3_video.upload_avg_speed.mean'),
  //   promise: () => response => response.result[0].values[0][1]
  // },
  // recordings: {
  //   getPath: generateIOBeamURL('record.start.sum', 'sum', '7d', '30d'),
  //   promise: () => response => response.result[0].values[0][1]
  // },
  // reboots: {
  //   getPath: generateIOBeamURL('reboots.sum', 'sum', '7d', '30d'),
  //   promise: () => response => response.result[0].values[0][1]
  // },
};

(0, _reduxUtils.fillActionsListWithActions)(BASE_CAMERA_ACTION, cameraActionsList);

var initialState = (0, _reduxUtils.getInitialState)(cameraActionsList);

function cameraRedux() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (0, _reduxUtils.defaultProcessingOfActions)(state, action, cameraActionsList);
}

function camerasBySn() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return (0, _reduxUtils.defaultLoadSubField)(state, action, BASE_CAMERA_ACTION, cameraRedux);
}

function loadPartialInfo(cameraInfo) {
  return {
    type: cameraActionsList.root.actions[1],
    id: cameraInfo.serial_number,
    result: cameraInfo
  };
}

function loadIfNeeded(sn) {
  var subQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cameraActionsList.root;

  return (0, _reduxUtils.loadIfNeeded)(sn, subQuery);
}

function fetchRelevantCameraInfo(cameraPartialInfo, dispatch) {
  var forceRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  console.log(cameraPartialInfo + forceRefresh);

  _promise2.default.all([dispatch(loadPartialInfo(cameraPartialInfo)), dispatch((0, _customers.loadIfNeeded)(cameraPartialInfo.owner.email, _customers.customerActionsList.subscription)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.ioBeam)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.dynamoDB)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.wifiDataReq)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.errorDataReq)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.badFlashReq)),

  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.drasticAction)),
  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.wifiBitrate)),
  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.videoUploadSpeed)),
  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.recordings)),
  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.reboots)),

  dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.sight)), dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.users))]
  // dispatch(loadIfNeeded(cameraPartialInfo.serial_number, cameraActionsList.schedule)),
  );

  // Make this dispatch async?
  dispatch((0, _firmware.fetchFirmwareVersionIfNeeded)((0, _kunaUtils.getModelFromSN)(cameraPartialInfo.serial_number)));
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/cameras.js
 ** module id = 336
 ** module chunks = 0
 **/